module.exports = __webpack_public_path__ + "static/media/s1.02b97697.pdf";